import React from 'react';
import PropTypes from 'prop-types';
import InViewObserver from 'components/InViewObserver';

class Iframe extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      isIframeInView: false,
    };
  }
  render() {
    if (this.props.loadIframeInView) {
      return (
        <InViewObserver
          inViewCallback={() => {
            this.setState({ isIframeInView: true });
          }}
          viewMargin={this.props.viewMargin}
        >
          {this.state.isIframeInView && (
            <iframe title={this.props.title} {...this.props} />
          )}
        </InViewObserver>
      );
    }
    return <iframe title={this.props.title} {...this.props} />;
  }
}

Iframe.propTypes = {
  loadIframeInView: PropTypes.bool,
  viewMargin: PropTypes.string,
  title: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};

Iframe.defaultProps = {
  loadIframeInView: false,
  viewMargin: '400px 0px 400px 0px',
};

export default Iframe;
